// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"w6-z"};